import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import * as Colors from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import * as Consts from './Consts.js';
import styles from './ImageDialogStyles';
import Tooltip from 'material-ui/internal/Tooltip';
import cookie from 'react-cookie';
import LinearProgress from 'material-ui/LinearProgress';

const EXPLANATION_SHOWED_COOKIE = 'c51ExplanationShowed';

export default class Camera51TouchUp extends PureComponent {
  static contextTypes = {
    muiTheme: PropTypes.object
  };

  static childContextTypes = {
    muiTheme: PropTypes.object
  };

  state = {showExplanation: true, loading: true, preview: false};

  getChildContext() {
    return {
      muiTheme: _.merge(this.context.muiTheme, {flatButton: {
        secondaryTextColor: Colors.red500,
      }})
    };
  }

  componentWillMount() {
    if (cookie.load(EXPLANATION_SHOWED_COOKIE)) {
      this.setState({showExplanation: false});
    }
  }

  componentDidMount() {
    const {c51TrackId, onComplete} = this.props;
    window.initCamera51({
      apiUrl: window.___editorData.settings.c51ApiUrl,
      elementId: 'camera51-touchup',
      customerId: 201,
      trackId: c51TrackId,
      decreaseInnerHeight: 30,
      wrappermarginTop: 20,
      transparent: true,
      callbackStartLoader: () => {
        this.setState({loading: true});
      },
      callbackStopLoader: (origin) => {
        if (origin !== window.camera51.obj.RETURN_IFRAME) {
          this.setState({loading: false});
        }
      },
      callbackFuncSave: onComplete,
      returnFromShowResult: () => {
        this.setState({preview: false});
      },
      callBackError: console.error.bind(this),
    });
  }

  hideExplanation = () => {
    this.setState({showExplanation: false});
    cookie.save(EXPLANATION_SHOWED_COOKIE, true);
  };

  render() {
    const {onCancel} = this.props;
    const {showExplanation, loading, preview} = this.state;
    return (<div
      style = {{position: 'relative', height: Consts.DIALOG_HEIGHT, maxHeight: Consts.MUI_DIALOG_MAX_HEIGHT}}
    >
      <div
        style = {styles.header}
      >
        <div style={{position: 'absolute', bottom: 5, left: 20}}>
          <FlatButton
            primary
            label="mark object"
            icon={<FontIcon className="material-icons">add_circle</FontIcon>}
            onClick = {() => {window.camera51.setColor('colorFG');}}
          />
          <FlatButton
            secondary
            label="mark background"
            icon={<FontIcon className="material-icons">remove_circle</FontIcon>}
            onClick = {() => {window.camera51.setColor('colorBG');}}
          />
          <FlatButton
            disabled = {preview}
            label="undo"
            labelStyle = {{color: preview ? Colors.grey400 : 'black'}}
            onClick = {() => {window.camera51.undo();}}
          />
        </div>
      </div>
      <div
        style={{...styles.tabContent, overflow: 'hidden'}}
      >
        <div
          style= {{width: '100%', height: '100%'}}
          id="camera51-touchup"
        />
        {
          loading &&
            <div
              style={{backgroundColor: Colors.white, position: 'absolute', top: 0, left: -2, width: 'calc(100% + 4px)'}}
            >
              <LinearProgress mode="indeterminate"/>
            </div>
        }
        <div
          style = {{position: 'absolute', top: 50, left: 80}}
        >
          <Tooltip
            style = {{backgroundColor: 'rgb(97, 97, 97)', zIndex: 4000}}
            show = {showExplanation}
            label={<div style={{padding: 10, display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                <div style={{fontSize: 16, fontWeight: 300, paddingBottom: 10}}>
                Use <span style={{fontSize: 14, color: Colors.red500, fontWeight: 400}}>MARK BACKGROUND</span> to adjust the background.<br/>
                Use <span style={{fontSize: 14, color: Colors.lightGreen500, fontWeight: 400}}>MARK OBJECT</span> for the object.<br/>
                The Background Remover will automatically make adjustments,<br/>
                so there is no need to be precise.
                </div>
                <FlatButton
                  label="got it"
                  labelStyle= {{color: Colors.lightGreen500}}
                  onClick = {this.hideExplanation}
                />
              </div>}
            verticalPosition="top"
            horizontalPosition="right"
          />
        </div>
        <div
          style = {{position: 'absolute', display: 'flex', flexDirection: 'column', top: 30, left: 30}}
        >
          <IconButton
            iconStyle = {styles.zoomButton}
            iconClassName="material-icons"
            onMouseDown = {() => {window.camera51.onclickLongZoomIn();}}
            onMouseUp = {() => {window.camera51.onmouseupLongZoomIn();}}
          >
            zoom_in
          </IconButton>
          <IconButton
            iconStyle = {styles.zoomButton}
            iconClassName="material-icons"
            onMouseDown = {() => {window.camera51.onclickLongZoomOut();}}
            onMouseUp = {() => {window.camera51.onmouseupLongZoomOut();}}
          >
            zoom_out
          </IconButton>
        </div>
      </div>
      <div
        style = {styles.buttonsSection}
      >
        {!preview && <FlatButton
          label = "back"
          onClick = {onCancel}
          labelStyle = {{color: Colors.grey800}}
        />}
        <FlatButton
          primary
          style = {{margin: 20, minWidth: 146}}
          label = {preview ? 'back' : 'preview result'}
          onClick = {() => {window.camera51.showResult(); this.setState({preview: !preview});}}
        />
        <RaisedButton
          primary
          label = "save changes"
          style = {styles.mainButton}
          onClick = {() => {window.camera51.saveImage();}}
        />
      </div>
      {
        (loading || showExplanation) &&
        <div
          style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', cursor: loading ? 'wait' : null}}
          onClick = {this.hideExplanation}
        />
      }
    </div>);
  }
}